// Browser shim for node:fs. The SDK's SessionLog / FixtureRecorder import
// these but only CALL them when a file path is provided. The client-only
// build never passes a path (in-memory logs), so these no-ops are only
// import-satisfiers and are never actually invoked.
export function appendFileSync(): void {}
export function existsSync(): boolean {
  return false;
}
export function mkdirSync(): void {}
export function writeFileSync(): void {}
export function readFileSync(): string {
  return "";
}
